import { Button } from 'antd';
import {
  EnterpriseOrderAiServiceModal,
  OrderAiServiceModal,
  OrderAiServiceModalProps,
  useGetTrafficPkgInfo,
} from '../OrderAiService';
import useModal from 'hooks/useModal';
import { useTranslate } from '@tolgee/react';
import { useIsEnterprisePkg } from '../../hooks/useComboInfo';
import { isUndefined } from 'lodash-es';
import {
  OrderLightWeightAiServiceModal,
  OrderLightWeightAiServiceModalProps,
  useGetLightWeightPkgInfo,
} from '../OrderLightWeightAiService';
import { statsSource } from 'services/api/notice';

export const OpenTrafficOrderModalButton = () => {
  const { show, visible, meta, hide } = useModal<OrderAiServiceModalProps>();
  const { loading, runAsync } = useGetTrafficPkgInfo();
  const { t } = useTranslate();
  const isEnterprisePkg = useIsEnterprisePkg();
  if (isUndefined(isEnterprisePkg)) return null;
  if (isEnterprisePkg) return null;

  return (
    <>
      {meta && visible && (
        <OrderAiServiceModal visible={visible} onClose={() => hide()} {...meta} />
      )}
      <Button
        loading={loading}
        onClick={() => {
          runAsync().then((data) => {
            show({
              trafficPkgInfo: data,
            });
          });
        }}
      >
        {t('order_ai_buyer_count')}
      </Button>
    </>
  );
};

export const OpenEnterpriseTrafficOrderModalButton = () => {
  const { show, visible, meta, hide } = useModal<OrderAiServiceModalProps>();
  const { loading, runAsync } = useGetTrafficPkgInfo();
  const { t } = useTranslate();
  const isEnterprisePkg = useIsEnterprisePkg();
  if (isUndefined(isEnterprisePkg)) return null;
  if (!isEnterprisePkg) return null;

  return (
    <>
      {meta && visible && (
        <EnterpriseOrderAiServiceModal visible={visible} onClose={() => hide()} {...meta} />
      )}
      <Button
        loading={loading}
        className="!pr-0"
        onClick={() => {
          runAsync().then((data) => {
            show({
              trafficPkgInfo: data,
            });
          });
        }}
        type="link"
      >
        {t('aiorder_enterprise_order_btn')}
      </Button>
    </>
  );
};

export const OpenOrderLightWeightModalButton = (props: { source: string }) => {
  const { source } = props;
  const { show, visible, meta, hide } = useModal<OrderLightWeightAiServiceModalProps>();
  const { loading, mutateAsync } = useGetLightWeightPkgInfo();
  const { t } = useTranslate();
  const isEnterprisePkg = useIsEnterprisePkg();
  if (isUndefined(isEnterprisePkg)) return null;
  if (isEnterprisePkg) return null;

  return (
    <>
      {meta && visible && (
        <OrderLightWeightAiServiceModal visible={visible} onClose={() => hide()} {...meta} />
      )}
      <Button
        loading={loading}
        onClick={() => {
          statsSource({
            id: 0,
            type: 1,
            source: source,
          });
          mutateAsync().then((data) => {
            show({
              lightWeightPkgInfo: data,
            });
          });
        }}
      >
        {t('订购AI精准回复能力护航的订单数')}
      </Button>
    </>
  );
};
